import { Pipe, PipeTransform } from '@angular/core';
import { FavoritesData } from '../providers/favorites';

@Pipe({
    name: 'isFavorite'
})

export class isFavoritePipe implements PipeTransform {

    constructor(
        private favoriteData: FavoritesData
    ) {

    }

    transform(value: string, uid: string): any {
        return this.favoriteData.getFavorite(uid, value);
    }
}


// WEBPACK FOOTER //
// ./src/pipes/favorites.pipe.ts